import React, { useEffect, useState } from 'react'
import { Button, Columns, Form, Icon } from 'react-bulma-components'
import { ClipboardCopyIcon } from '@heroicons/react/solid'
import { CheckIcon } from '../icons'

export const SUPPORT_EMAIL = 'support@teamtim.fr'

const SupportEmail: React.FC = () => {
  const [copy, setCopy] = useState(false)

  useEffect(() => {
    if (copy) {
      navigator.clipboard.writeText(SUPPORT_EMAIL)
    }
  }, [copy])

  return (
    <Columns centered>
      <Columns.Column narrow>
        <Form.Field kind="addons">
          <Form.Control>
            <Form.Input
              type="text"
              value={SUPPORT_EMAIL}
              textColor="primary"
              textWeight="bold"
              readOnly
            />
          </Form.Control>
          <Form.Control>
            <Button color="primary" onClick={() => setCopy(true)}>
              {copy ? (
                <>
                  <Icon>
                    <CheckIcon />
                  </Icon>
                  <span>Copié</span>
                </>
              ) : (
                <>
                  <Icon>
                    <ClipboardCopyIcon />
                  </Icon>
                  <span>Copier</span>
                </>
              )}
            </Button>
          </Form.Control>
        </Form.Field>
      </Columns.Column>
    </Columns>
  )
}

export default SupportEmail
